import request from './request'

export function generatePrompt(data) {
    return request({
        url: '/generate_prompt',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export function uploadImg(dir, file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('dir', dir);

    console.log('上传的文件:', file);
    console.log('上传的表单数据:', formData.get('file'));

    return request({
        url: '/api/upload/image',
        method: 'post',
        data: formData
    })
}


export function wsUploadFile(params, formData) {
  Object.entries(params).forEach(([key, value]) => {
    formData.append(key, value);
  });

  return request({
    url: '/api/upload/ws/uploadToObs',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export function lxUploadFile( formData) { 
    return request({
        url: '/api/upload/imageObs',
        method: 'post', 
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}
export function yyzzUploadFile( formData) {
    return request({
        url: '/api/ocr/businessLicense',
        method: 'post', 
        data: formData,
    });
}